import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InfoTab } from './InfoTab';
import { TableTab } from './TableTab';
import { ChartsTab } from './ChartsTab';
import { CoreOrientationTab } from './CoreOrientationTab';
import { hasCoreTrakRuns } from '../../drillholeSummary';
import { FaChartBar, FaTable, FaInfo, FaCompass } from 'react-icons/fa';

export const DrillholeSummary = ({project, drillhole, summary, handleDrillholeUpdate, industry }) => {
    const { t } = useTranslation();
    const [, setSelectedSurvey] = useState({});
    const [tabContent, setTabContent] = useState('info');
    // The survey the Table tab should open on when it is reached from a link
    // (the Core Orientation table's survey column). Null when the Table button
    // itself is used, which keeps the tab's usual first-survey default.
    const [tableFileId, setTableFileId] = useState(null);

    const openSurveyInTable = (fileId) => {
        setTableFileId(fileId);
        setTabContent('table');
    }

    const handleSurveySelect = (surveyReference) => {
        setSelectedSurvey(surveyReference);
    }

    const handleDrillholeDelete = () => {
        if (window.confirm(t('drillholes.confirmDelete'))) {
            fetch('api/projects/deletedrillhole', {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'project': project.name,
                    'drillhole': drillhole.name
                }
            })
                .then(response => response.json())
                .then(data => {
                    console.log('Success:', JSON.stringify(data, null, 2));
                    handleDrillholeUpdate(data);
                });
        }
    }

    useEffect(() => {
        setSelectedSurvey({});
        setTabContent('info');
        setTableFileId(null);
    }, [drillhole]);

    const renderTabContent = () => {
        switch (tabContent) {
            case 'info':
                return <InfoTab project={project} drillhole={drillhole} handleDrillholeDelete={handleDrillholeDelete} handleDrillholeEdit={(map) => handleDrillholeUpdate(map)} />;
            case 'table':
                return <TableTab drillhole={drillhole} initialFileId={tableFileId} handleDrillholeUpdate={(map) => handleDrillholeUpdate(map)} industry={industry} />;
            case 'charts':
                return <ChartsTab drillhole={drillhole} />;
            case 'core':
                return <CoreOrientationTab drillhole={drillhole} industry={industry} onOpenSurvey={openSurveyInTable} />;
            default:
                return <p>{t('drillholes.info')}</p>;
        }
    }


    let contents = '';

    if (drillhole.name) {
        contents = (
            <div className="row">
                <div className="col-lg-12">
                    <div className="d-flex">
                        <h3>{drillhole.name}</h3>
                        <button className="btn btn-primary ms-auto" style={{ marginRight: 10 }} onClick={() => { handleSurveySelect({}); setTabContent('info'); }}><FaInfo /> {t('drillholes.info')}</button>
                        <button className="btn btn-primary" disabled={drillhole.surveys.length < 1} style={{ marginRight: 10 }} onClick={() => { handleSurveySelect({}); setTableFileId(null); setTabContent('table'); }}><FaTable /> {t('drillholes.table')}</button>
                        <button className="btn btn-primary" disabled={drillhole.surveys.length < 1} style={{ marginRight: 10 }} onClick={() => { handleSurveySelect({}); setTabContent('charts'); }}><FaChartBar /> {t('drillholes.charts')}</button>
                        {/* Only on a hole that holds a CoreTrak run. Known from the hole's summary,
                            since the map cannot say which tool a survey came from. */}
                        {hasCoreTrakRuns(summary) && <button className="btn btn-primary" style={{ marginRight: 10 }} onClick={() => { handleSurveySelect({}); setTabContent('core'); }}><FaCompass /> {t('drillholes.coreOrientation')}</button>}
                    </div>
                </div>
                <hr style={{ marginTop: 10 }} />
                <div className="col-lg-12">
                    {renderTabContent()}
                </div>
            </div>
        );
    }

    return (
        <div>
            {contents}
        </div>
    );
}
